module.exports = __webpack_public_path__ + "img/ide-kit.d35d9231.svg";